(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name manageRoles.factory:ManageRolesAdaptorFactory
     *
     * @description
     *
     */
    angular
        .module('manageRoles')
        .factory('ManageRolesAdaptorFactory', ManageRolesAdaptorFactory);
    
    function ManageRolesAdaptorFactory() {
        
        function MultiSelectNode() {
            this.labelFieldName = null;
            this.valueFieldName = null;
            this.childElements = null;
            this.selected = true;
        }
        
        var reAdaptPrivileges = function (privileges) {
            var returns = [];
            _.each(privileges, function (privilege) {
            	if(privilege.childElements === null){
                returns.push(privilege.valueFieldName);
            	}else{ 
            		_.each(privileges, function (privilege) { 
            		_.each(privilege.childElements, function (childElements) {
            			if(childElements.selected){
            				returns.push(childElements.valueFieldName);
            			}
                	});
                	});
            	}
            });
            return returns
        };

        var adaptPrivileges = function (privileges) {
            return _.map(privileges, function(item){
                var parentNode = new MultiSelectNode();
                parentNode.labelFieldName = item.category;
                parentNode.valueFieldName = item.category;
                var temp = _.map(item.privilages, function(priv){
                    var childNode = new MultiSelectNode();
                    childNode.valueFieldName = priv.privilageID;
                    childNode.labelFieldName = priv.privilageName;
                    return childNode;
                });
                parentNode.childElements = temp;
                return parentNode
            });
        };
        
        var adaptPrivilegesToDisplay = function (privileges) {
            return _.map(privileges, function(privilege){
                var childNode = new MultiSelectNode();
                childNode.valueFieldName = privilege.privilageID;
                childNode.labelFieldName = privilege.privilageName;
                return childNode;
            });
        };

        return {
            adaptPrivileges: adaptPrivileges,
            reAdaptPrivileges: reAdaptPrivileges,
            adaptPrivilegesToDisplay: adaptPrivilegesToDisplay
        }
    }
})();